export default __webpack_public_path__ + "static/media/StarfishFiction.ab6bde17.png";